(function () {
  'use strict';

  var MIN_INTERACTION_MS = 2000;

  function initForm(form) {
    if (form.dataset.spamGuardInit === 'true') return;
    form.dataset.spamGuardInit = 'true';

    var honeypot = form.querySelector('[data-spam-honeypot]');
    var interactionAt = null;

    form.addEventListener(
      'focusin',
      function () {
        if (!interactionAt) interactionAt = Date.now();
      },
      true
    );

    form.addEventListener('submit', function (event) {
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (interactionAt && Date.now() - interactionAt < MIN_INTERACTION_MS) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
